import { PayCorrectionEmployeeItem } from 'apps/sigma2-ui/src/pay-correction/components/PayCorrectionTable';

export const filterEmployeesByMinorityGender = ({
  isMinorityDimensionLevel,
  items,
}: {
  isMinorityDimensionLevel: (
    columnHeaderValue: string,
    columnValue: string,
  ) => boolean;
  items: PayCorrectionEmployeeItem[];
}): PayCorrectionEmployeeItem[] => {
  return items.filter((emp) => {
    const employeeGender = emp.gender;

    if (!employeeGender) {
      return false;
    }

    return isMinorityDimensionLevel('Gender', employeeGender);
  });
};

export const filterEmployeesByMinorityRace = ({
  isMinorityDimensionLevel,
  items,
}: {
  isMinorityDimensionLevel: (
    columnHeaderValue: string,
    columnValue: string,
  ) => boolean;
  items: PayCorrectionEmployeeItem[];
}): PayCorrectionEmployeeItem[] => {
  return items.filter((emp) => {
    const employeeRace = emp.race;

    if (!employeeRace) {
      return false;
    }

    return isMinorityDimensionLevel('Race', employeeRace);
  });
};
